module.exports = __webpack_public_path__ + "img/security-net.a7eec707.svg";